import React, { useEffect } from "react";
import { createPortal } from "react-dom";
import { GrClose } from "react-icons/gr";
import PropTypes from "prop-types";

const Modal = ({ visible, onClose, children }) => {
    useEffect(() => {
        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };
        document.addEventListener("keydown", handleEsc);
        return () => document.removeEventListener("keydown", handleEsc);
    }, [onClose]);

    if (!visible) return null;

    return createPortal(
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-text bg-opacity-50">
            <div
                onClick={onClose}
                className="absolute inset-0"
            />
            <div
                className="relative bg-white max-w-lg w-full mx-4 rounded-lg shadow-lg p-6 z-[10000]"
                onClick={(e) => e.stopPropagation()}
            >
                <GrClose
                    className="absolute top-4 right-4 cursor-pointer text-gray-600"
                    size="20px"
                    onClick={onClose}
                />
                {children}
            </div>
        </div>,
        document.body
    );
};

Modal.propTypes = {
    visible: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    children: PropTypes.node.isRequired,
};

export default Modal;
